import { render, staticRenderFns } from "./SingleProductItemDetails.vue?vue&type=template&id=353470ae&scoped=true&"
import script from "./SingleProductItemDetails.vue?vue&type=script&lang=js&"
export * from "./SingleProductItemDetails.vue?vue&type=script&lang=js&"
import style0 from "./SingleProductItemDetails.vue?vue&type=style&index=0&id=353470ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353470ae",
  null
  
)

export default component.exports